
import { Container, TextStyle, Text, Graphics, Sprite } from 'pixi.js'
export default class HandIndicator extends Sprite {
    constructor(color, ...arg) {
        super(...arg);
    
        this.color = color || 0xFFFF00 || 0x479ACE;// or 0x479ACE or 0xC03500;
      
        var background = new Graphics();
        //background.beginFill(this.color );
        background.lineStyle(4, 0xFFFF00, 1);
        //background.drawRect(0, 0, 105, 105);
        background.drawRoundedRect(-2, -2, 504, 184, 10);
        //background.alpha = 0.8;
        this.addChild(background);
    }
   
}